import { render, staticRenderFns } from "./LoginRulesNotify.vue?vue&type=template&id=345d8a8c&scoped=true"
import script from "./LoginRulesNotify.vue?vue&type=script&lang=js"
export * from "./LoginRulesNotify.vue?vue&type=script&lang=js"
import style0 from "./LoginRulesNotify.vue?vue&type=style&index=0&id=345d8a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345d8a8c",
  null
  
)

export default component.exports